// extracted by mini-css-extract-plugin
export default {"clone-img":"CloneImg_clone-img__xPCMU","clone-spn":"CloneImg_clone-spn__7+k-e"};